import { Box } from '@mui/material';
import React, { useEffect, useState } from 'react';
import useFetch from '../../api/useFetch';
import { StorageDisk } from './network-storage/StorageDisk';
import { NetworkStorageForm } from './network-storage/NetworkStorageForm';
import ExoDialog from '../../components/exo/ExoDialog';
import StorageIcon from '@mui/icons-material/Storage';
import {
  ExoTableToolbar,
  ExoTableToolbarItem,
} from '../../components/exo/ExoTableToolbar';
import { useTranslation } from 'react-i18next';
import { updateOrCreate } from '../../components/special/updateOrCreate';

export const NetworkStorage = ({ onFeedback }) => {
  const { t } = useTranslation();

  const { apiData, setApiData } = useFetch(`network-storages`);

  // form === null -> closed. Otherwise { startStep, data }.
  const [form, setForm] = useState(null);

  // Resume the wizard at step 2 after an OAuth provider redirected back.
  useEffect(() => {
    const marker = localStorage.getItem('networkStorageSetup');
    if (!marker) return;
    localStorage.removeItem('networkStorageSetup');
    try {
      const parsed = JSON.parse(marker);
      if (parsed?.id) setForm({ startStep: 1, data: parsed });
    } catch (e) {
      // ignore malformed marker
    }
  }, []);

  function handleResponse(data) {
    setApiData(updateOrCreate(apiData, data));
  }

  function handleCloseForm() {
    setForm(null);
  }

  function handleDelete(itemToDelete) {
    const newItems = apiData.data.filter((obj) => obj.id !== itemToDelete.id);
    setApiData({ ...apiData, data: newItems });
  }

  return (
    <Box className="flex flex-col w-full">
      <ExoTableToolbar>
        <ExoTableToolbarItem
          onClick={() => setForm({ startStep: 0, data: null })}
          text={t('New Network Storage')}
          icon={<StorageIcon />}
        />
      </ExoTableToolbar>
      <Box className="w-full grid grid-cols-2 md:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 gap-4">
        {apiData &&
          apiData.data.map((disk) => (
            <StorageDisk
              key={disk.id}
              disk={disk}
              onEdit={(d) => setForm({ startStep: 1, data: d })}
              onDelete={handleDelete}
            />
          ))}
        <ExoDialog open={Boolean(form)} onClose={handleCloseForm} limitWidth>
          {form && (
            <NetworkStorageForm
              onClose={handleCloseForm}
              onCreate={handleResponse}
              startDataCollection={form.data}
              startStep={form.startStep}
            />
          )}
        </ExoDialog>
      </Box>
    </Box>
  );
};
